import {
  saveStateToHistoryAction,
  saveStateToHistoryActionSaleJet,
  clearStateHistoryAction,
  removeStateFromHistoryAction,
  setReturnUrl,
} from '../utilities/stateHistory/stateHistorySlice';
import {pushHistoryKey, getPreviousHistoryKeyAndPop, loadStateFromHistory, clearHistoryKeyStack} from '../utilities/stateUtils';
import Config from '../Config';
import {setIsSubmit} from '../Components/Block/SaleBlock/saleBlockSlice';
import {pushPath} from '../utilities/routing/routingSlice';
import {stepEnum, successEnum} from '../Components/Block/DebtPaymentBlock/DebtPaymentComponents/debtPaymentEnum';
import {restoreFromHistory} from '../utilities/stateHistory/stateHistorySlice';
const saveStateToHistory = () => saveStateToHistoryAction(`${window.location.pathname}::${window.location.hash}`);
const saveStateToHistoryWithParams = () =>
  saveStateToHistoryAction(`${window.location.pathname + window.location.search}::${window.location.hash}`);
export default (store) => (next) => async (action) => {
  //Note: for sync actions - just first change state and then save to history. For async actions - listen on fulfilled/rejected action and save to history.
  const state = store.getState();

  if (typeof window !== 'undefined') {
    const prevPathname = sessionStorage.getItem('prevPathname');
    const currentPathname = window.location.pathname;

    if (currentPathname !== prevPathname) {
      sessionStorage.setItem('prevPathname', currentPathname);
      const pageLoadCounter = parseInt(sessionStorage.getItem('pageLoadCounter') || 0) + 1;
      sessionStorage.setItem('pageLoadCounter', pageLoadCounter);
      sessionStorage.setItem('prevFullUrl', sessionStorage.getItem('currentFullUrl'));
      sessionStorage.setItem('currentFullUrl', window.location.href);
    }
    if (action.type === 'RESET_APP' && state.stateHistory.returnUrl) {
      let returnUrl = state.stateHistory.returnUrl;
      await store.dispatch(setReturnUrl(false));
      await store.dispatch(clearStateHistoryAction());
      window.location.replace(Config.staticWebSiteUrl + returnUrl);
    }
    if (action.type === 'RESET_APP') {
      if (state.saleBlock.page != 'welcomePage' && state.saleBlock.page != 'addressFormPage' && state.saleBlock.page != '') {
        var storage = window.localStorage || window.sessionStorage;
        storage.setItem('previousPage', state.saleBlock.page);
      }
      return next(action);
    }
    if (action.type === 'UPDATE_PATH' && state.stateHistory.returnUrl) {
      await store.dispatch(setReturnUrl(''));
    }

    if (action.type === 'disconnectClientService/goToPage') {
      await store.dispatch(saveStateToHistory());
      next(pushPath(action.payload?.page || undefined));
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'disconnectClientServiceSlice/getEquipmentForProduct/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'disconnectClientServiceSlice/disconnectProduct/fulfilled') {
      store.dispatch(clearStateHistoryAction());
    } else if (action.type === 'disconnectClientServiceSlice/checkCanUpgradeCellularProgram/fulfilled') {
      store.dispatch(clearStateHistoryAction());
    } else if (action.type === 'catalog/addCheckedCard') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'SetUpDeliveries/getDeliverySlots/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'chooseCellularServices/initDataCellularServices') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'catalog/addCheckedCard') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'debtPayment/handleCurrentStep') {
      if (action.payload) {
        await store.dispatch(saveStateToHistory());
        next(action);
        if (!action.payload.skipStep) {
          if (!store.getState().stateHistory.isStateReset && action.payload.currentStep !== stepEnum.START) {
            next(pushPath(action.payload.currentStep));
          }
          if (action.payload.currentStep === successEnum.PAYMENTSUCCESS) {
            return await store.dispatch(setReturnUrl(Config.businessLobbyUrl));
          } else {
            return await store.dispatch(saveStateToHistory());
          }
        }
      }
    } else if (action.type === 'debtPayment/clearHistory') {
      return await store.dispatch(clearStateHistoryAction());
    }
    // //------------------- Debt payment new -------------------//
    else if (action.type === 'debtAndUpdatePayment/backHistory') {
      const previousKey = getPreviousHistoryKeyAndPop(action);
      if (previousKey) {
        const loadedState = loadStateFromHistory(previousKey);
        if (loadedState?.debtAndUpdatePayment) {
          next(restoreFromHistory('debtAndUpdatePayment', loadedState.debtAndUpdatePayment));
          store.dispatch(pushPath(loadedState.debtAndUpdatePayment.currentStep));
        }
      }
      return next(action);
    } else if (action.type === 'debtAndUpdatePayment/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
        await store.dispatch(saveStateToHistory());
        pushHistoryKey(action);
        return;
      }
    } else if (action.type === 'debtAndUpdatePayment/clearHistory') {
      clearHistoryKeyStack(action.type);
      await store.dispatch(setReturnUrl(action.payload));
      return await store.dispatch(clearStateHistoryAction());
    }
    // //------------------- Cellcom Abroad -------------------//
    else if (action.type === 'cellcomAbroad/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'cellcomAbroad/removeStateFromHistoryAction') {
      await store.dispatch(removeStateFromHistoryAction(action.payload.key));
    } else if (action.type === 'cellcomAbroad/clearHistory') {
      await store.dispatch(setReturnUrl(action.payload));
      return await store.dispatch(clearStateHistoryAction());
    } else if (action.type === 'cellcomAbroad/getCustomerAbroadPackages/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'cellcomAbroad/getCustomerAbroadUsageDisplay/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    }
    //------------------- Cellcom Abroad end  -------------------//
    else if (action.type === 'addressForm/setIsShowPopUp') {
      if (action.payload) {
        await store.dispatch(setIsSubmit({isSubmit: false}));
        await store.dispatch(saveStateToHistory());
        next(action);
        next(pushPath('chooseEntrance'));
        return await store.dispatch(saveStateToHistory());
      }
    } else if (action.type === 'premiumPackages/goToPage') {
      await store.dispatch(saveStateToHistory());
      next(pushPath(action.payload || undefined));
      next(action);
      return await store.dispatch(saveStateToHistory());
    }
    //------------------- fundial -------------------
    else if (action.type === 'fundialPage/initFundial') {
      // await store.dispatch(saveStateToHistory());
      // // next(pushPath('lobbyPage'));
      // next(action);
      // return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'fundialPage/goToPage') {
      let pageName = action.payload.page;
      await store.dispatch(saveStateToHistory());
      next(pushPath(pageName));
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'fundialPage/pageLoaded') {
      await store.dispatch(saveStateToHistory());
    }
    //------------------- otp -------------------
    else if (action.type === 'otp/otpReportStep') {
      let pageName = 'otpPage' + action.payload;
      await store.dispatch(saveStateToHistory());
      next(pushPath(pageName));
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'addressForm/addressReportStep') {
      let pageName = 'addressFormPage' + action.payload;
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistory());
    }
    //--------------- Update Payment --------------------
    else if (action.type === 'updatePayment/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'updatePayment/clearHistory') {
      return await store.dispatch(clearStateHistoryAction());
    } else if (action.type === 'updatePayment/handleCurrentStep') {
      if (
        action.payload != 6 &&
        (state.updatePayment.isBusinessBlock || (!state.updatePayment.isBusinessBlock && (action.payload == 5 || action.payload == 3)))
      ) {
        if (!state.updatePayment.isBusinessBlock && action.payload == 3) {
          next(action);
          return await store.dispatch(saveStateToHistory());
        } else {
          next(pushPath(action.payload));
          next(action);
          return await store.dispatch(saveStateToHistory());
        }
      }
    } else if (action.type === 'updatePayment/updatePaymentMethod/pending') {
      await store.dispatch(setReturnUrl(Config.businessLobbyUrl));
    }
    //--------------------Update Payment end--------------------
    //--------------------Change Price Plan--------------------
    else if (action.type === 'changePricePlan/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'changePricePlan/logoutOtp' || action.type === 'changePricePlan/clearHistory') {
      next(action);
      return await store.dispatch(clearStateHistoryAction());
    }
    //--------------------Change Price Plan--------------------
    //------------------- cellcomEnergy -------------------
    else if (action.type === 'cellcomEnergyBlock/initBlock') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'cellcomEnergyBlock/goToPage') {
      let pageName = action.payload;
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistory());
    }
    //------------------- cellcomEnergy -------------------
    else if (action.type === 'selfCreatedTechnicianVisitSlice/goToPage') {
      window.history.replaceState('lobby', '', Config.lobbyUrl);
      next(pushPath(action.payload || undefined));
      next(action);
      return await store.dispatch(clearStateHistoryAction());
    }
    // ------------------ Sale ----------------------------
    if (action.type === 'saleBlock/redirectToLogin') {
      next(action);
      return store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleBlock/navigateTo') {
      next(action);
      return store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleBlock/initSale') {
      var storage = window.localStorage || window.sessionStorage;
      storage.setItem('previousPage', '');
      next(action);
      if (action.payload.page == 'loginPage') {
        next(pushPath('loginPage'));
      }
      return store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleBlock/goToPage') {
      var storage = window.localStorage || window.sessionStorage;
      storage.setItem('previousPage', state.saleBlock.page);

      let pageName = action.payload.page;

      if (state.saleBlock.saleType == 'cellular') {
        if (
          action.payload.page == 'chooseNumberPage' ||
          action.payload.page == 'extraPage' ||
          action.payload.page == 'chooseTypeSIM' ||
          action.payload.page == 'newNumberPage'
        ) {
          pageName = action.payload.page + (state.saleBlock.productsInfo.selectedPhoneIndex + 1);
        }
      }

      if (state.saleBlock.page == 'loginPage') {
        var storage = window.localStorage || window.sessionStorage;
        storage.setItem('previousPage', '');
      }
      if (action.payload.page == 'successPage') {
        store.dispatch(clearStateHistoryAction());
      }
      if (state.saleBlock.page != 'loginPage') {
        store.dispatch(saveStateToHistory());
      }
      next(action);
      next(pushPath(pageName));
      return store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleBlock/setError') {
      next(pushPath('errorPage'));
      return next(action);
    }

    // ------------------- update technician-----------------------------
    else if (action.type === 'technicianUpdatesBlock/initTechnicianUpdates') {
      await store.dispatch(saveStateToHistory());
      next(pushPath('customerVisitInfoPage'));
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'technicianUpdatesBlock/goToPage') {
      let pageName = action.payload;
      await store.dispatch(saveStateToHistory());
      next(pushPath(pageName));
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'technicianUpdatesBlock/pageLoaded') {
      await store.dispatch(saveStateToHistory());
    }

    // ------------------- Stand Alone Purchase Sale -----------------------------
    else if (action.type === 'standAlonePurchaseSaleBlock/goToPage') {
      let pageName = action.payload.page;
      await store.dispatch(saveStateToHistory());
      next(pushPath(pageName));
      next(action);
      return await store.dispatch(saveStateToHistory());
    }
    // ------------------- Moving Apartment - movingBlock -----------------------------
    else if (action.type === 'movingBlock/initMoving') {
      let pageName = action.payload.page;
      if (pageName) {
        await store.dispatch(saveStateToHistory());
        next(pushPath(pageName));
      }
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'movingBlock/goToPage') {
      let pageName = action.payload;
      await store.dispatch(saveStateToHistory());
      next(pushPath(pageName));
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'movingBlock/setErrorPage') {
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath('errorPage'));
      return await store.dispatch(saveStateToHistory());
    }
    //------------------- saleJetBlock -------------------
    else if (action.type === 'saleJetBlock/initSale') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/goToPage') {
      let pageName = action.payload;
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/setErrorPage') {
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath('errorPage'));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/setLeadPage') {
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath('leadPage'));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/prepareSaleAsync/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/prepareSaleReplaceAsync/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/setDefaultConverter/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/getTechnicianTimesAsync/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/getFirstTechnicianTimeAsync/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/getCustomerAddresses/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/getDeliveryTimeSlots/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/setNewSalePackage/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/resetBlock') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/setCellularSettingList') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/resetCellularSettingsPage') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'SalePackagesBlock/resetSalePackagesBlock') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/getFullPrice/fulfilled') {
      next(action);
      await store.dispatch(
        saveStateToHistoryActionSaleJet({url: `${window.location.pathname}::#cellularsettingspage`, page: 'cellularSettingsPage'}),
      );
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/setSummaryDetails') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/setCellularSetting') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/setIsLoadingShoppingCart') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'saleJetBlock/editRemoveCellularItem/fulfilled') {
      next(action);
      await store.dispatch(saveStateToHistory());
      return await store.dispatch(
        saveStateToHistoryActionSaleJet({url: `${window.location.pathname}::#cellularsettingspage`, page: 'cellularSettingsPage'}),
      );
    }
    //------------------- esimUpgradeBlock -------------------
    else if (action.type === 'esimUpgradeBlock/goToPage') {
      let pageName = action.payload;
      if (pageName === 'successPage' || pageName === 'errorPage' || pageName === 'whatsAppSuccessPage') {
        await store.dispatch(clearStateHistoryAction());
      }
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'esimUpgradeBlock/setErrorPage') {
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath('errorPage'));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'esimUpgradeBlock/resetBlock') {
      next(action);
      return await store.dispatch(clearStateHistoryAction());
    }
    //------------------- esimQrCodeBlock -------------------
    else if (action.type === 'esimQrCodeBlock/goToPage') {
      let pageName = action.payload;
      if (pageName === 'errorPage' || pageName === 'whatsAppSuccessPage') {
        await store.dispatch(clearStateHistoryAction());
      }
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'esimQrCodeBlock/setErrorPage') {
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath('errorPage'));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'esimQrCodeBlock/resetBlock') {
      next(action);
      return await store.dispatch(clearStateHistoryAction());
    }
    // ------------------- PremiumPackagesCatalogBlock -----------------------------
    /*else if (action.type === 'premiumPackagesCatalog/initBlock') {
      next(action);
      return await store.dispatch(saveStateToHistoryWithParams());
    }*/
    else if (action.type === 'premiumPackagesCatalog/goToPage') {
      let pageName = action.payload;
      await store.dispatch(saveStateToHistoryWithParams());
      next(pushPath(pageName));
      next(action);
      return await store.dispatch(saveStateToHistoryWithParams());
    } else if (action.type === 'premiumPackagesCatalog/setErrorPage') {
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath('errorPage'));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'premiumPackagesCatalog/getCatalogAsync/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'premiumPackagesCatalog/premiumPackageActionAsync/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    }
    //------------------------------IMEI-----------------------------------
    else if (action.type === 'IMEIDeviceRepair/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'IMEIDeviceRepair/clearHistory') {
      await store.dispatch(setReturnUrl(Config.businessLobbyUrl));
      return await store.dispatch(clearStateHistoryAction());
    }
    //------------------------------Parental Code Reset-----------------------------------
    else if (action.type === 'tvActivationCodeRecoveryBlock/saveToHistory') {
      if (action.payload) {
        await store.dispatch(saveStateToHistory());
        next(pushPath(action.payload));
      }
      return await store.dispatch(saveStateToHistory());
    }
    //----------------------------------Idf Sale Block------------------------------
    else if (action.type === 'idfSaleBlock/pushToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'idfSaleBlock/saveToHistory') {
      if (action.payload) {
        return await store.dispatch(saveStateToHistory());
      }
    } else if (action.type === 'idfSaleBlock/clearHistory') {
      return await store.dispatch(clearStateHistoryAction());
    }
    //----------------------------------Update Mailing Method------------------------------
    else if (action.type === 'updateMailingMethod/saveToHistory') {
      if (action.payload) {
        // await store.dispatch(saveStateToHistory());
        next(pushPath(action.payload));
        return await store.dispatch(saveStateToHistory());
      }
    } else if (action.type === 'updateMailingMethod/clearHistory') {
      await store.dispatch(setReturnUrl(Config.businessLobbyUrl));
      return await store.dispatch(clearStateHistoryAction());
    }
    //----------------------------------Organization portal Method------------------------------
    else if (action.type === 'organizationPortal/saveToHistory' || action.type === 'orgUsersManagement/saveToHistory') {
      if (action.payload) {
        // await store.dispatch(saveStateToHistory());
        next(pushPath(action.payload));
        return await store.dispatch(saveStateToHistory());
      }
    } else if (action.type === 'familyMemberCellularSale/saveToHistory') {
      if (action.payload) {
        // await store.dispatch(saveStateToHistory());
        next(pushPath(action.payload));
        return await store.dispatch(saveStateToHistory());
      }
    }
    //----------------------------------IDF Change PricePlan Method------------------------------
    else if (action.type === 'idfNewPlanSignup/saveToHistory') {
      if (action.payload) {
        // await store.dispatch(saveStateToHistory());
        next(pushPath(action.payload));
        return await store.dispatch(saveStateToHistory());
      }
    } else if (action.type === 'IdfSurfingPackageExpansion/saveToHistory') {
      if (action.payload) {
        // await store.dispatch(saveStateToHistory());
        next(pushPath(action.payload));
        return await store.dispatch(saveStateToHistory());
      }
    } else if (action.type === 'energySaleBlock/goToPage') {
      if (action.payload) {
        await store.dispatch(saveStateToHistory());
        next(pushPath(action.payload));
        next(action);
        return await store.dispatch(saveStateToHistory());
      }
    } else if (action.type === 'energySaleBlock/initEnergySale') {
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'energySaleBlock/setErrorPage') {
      await store.dispatch(saveStateToHistory());
      next(pushPath('errorPage'));
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'energySaleBlock/saveToHistory') {
      return await store.dispatch(saveStateToHistory());
    }
    //----------------------------------Transfer Organization Account------------------------------
    else if (action.type === 'TransferOrganizationAccount/saveToHistory') {
      if (action.payload) {
        // await store.dispatch(saveStateToHistory());
        next(pushPath(action.payload));
        return await store.dispatch(saveStateToHistory());
      }
    }
    //----------------------------------Authentication------------------------------
    else if (action.type === 'authentication/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload,true));
      }
      pushHistoryKey(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'authentication/clearHistory') {
      sessionStorage.removeItem('thirdPartyPopupHasBeenShown'); //ThirdPartyAgreementsPopup Block
      sessionStorage.removeItem('selfCareCounter'); //ThirdPartyAgreementsPopup Block
      clearHistoryKeyStack(action.type);
      return await store.dispatch(clearStateHistoryAction());
    }else if (action.type === 'authentication/backHistory') {
      var stepToSkipe=["otp"];
      const previousKey = getPreviousHistoryKeyAndPop(action ,'session',stepToSkipe);
      if (previousKey) {
        const loadedState = loadStateFromHistory(previousKey);
        if (loadedState?.authentication) {
          next(restoreFromHistory('authentication', loadedState.authentication));
          store.dispatch(pushPath(loadedState.authentication.loginStep,true));
        }
      }
      return next(action);
    }
    //---------------------------------- Ownership Transfer ------------------------------
    else if (action.type === 'OwnershipTransfer/saveToHistory' || action.type === 'OwnershipTransferCustomer/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
        return await store.dispatch(saveStateToHistory());
      }
    }
    //---------------------------------- Change Phone Number ------------------------------
    else if (action.type === 'changePhoneNumber/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
        return await store.dispatch(saveStateToHistory());
      }
    } else if (action.type === 'selfcarePage/initPage') {
      const selfCareCounter = parseInt(sessionStorage.getItem('selfCareCounter') || 0) + 1;
      sessionStorage.setItem('selfCareCounter', selfCareCounter);
    } else if (action.type === 'selfcarePage/goToPage') {
      let pageName = action.payload;
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'personalAreaInvoicesPage/goToPage') {
      let pageName = action.payload;
      await store.dispatch(saveStateToHistoryWithParams());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistoryWithParams());
    } else if (action.type === 'personalAreaInvoicesPage/goToPageCallsDetails') {
      let pageName = action.payload;
      await store.dispatch(saveStateToHistoryWithParams());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistoryWithParams());
    } else if (action.type === 'personalAreaInvoicesPage/getAllProductsAsync/fulfilled') {
      next(action);
      return await store.dispatch(saveStateToHistoryWithParams());
    }
    //---------------------------------- Cellular Data On Off ----------------------------
    else if (action.type === 'cellularDataOnOffSlice/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'selfCareSuccessMsgBlock/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'zoneFaultBlock/goToPage') {
      let pageName = action.payload;
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'serviceAppointmentSchedulerBlock/goToPage') {
      let pageName = action.payload.page;
      if (action.payload.typePage) {
        pageName = pageName + '_' + action.payload.typePage;
      }
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'connectionDetailsBlock/goToPage') {
      let pageName = action.payload;
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'equipmentListPage/goToPage') {
      let pageName = action.payload;
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'genericWizardBlock/goToPage') {
      let pageName = action.payload.page;
      if (action.payload.screenId) {
        pageName = pageName + '_' + action.payload.screenId;
      }
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'speedTestAndDisconnectionsWizardBlock/initBlock') {
      let pageName = action.payload.page;
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'speedTestAndDisconnectionsWizardBlock/goToPage') {
      let pageName = action.payload.page;
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'speedTestAndDisconnectionsWizardBlock/onSelectedSubscriber') {
      // await store.dispatch(saveStateToHistory());
      next(action);
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'wifiManagementBlock/goToPage') {
      let pageName = action.payload;
      await store.dispatch(saveStateToHistory());
      next(action);
      next(pushPath(pageName));
      return await store.dispatch(saveStateToHistory());
    }
    //---------------------------------- Business Work Order System ------------------------------
    else if (action.type === 'businessWorkOrderSystem/pushToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'businessWorkOrderSystem/saveToHistory') {
      if (action.payload) {
        return await store.dispatch(saveStateToHistory(action.payload));
      }
    } else if (action.type === 'businessWorkOrderSystem/clearHistory') {
      return await store.dispatch(clearStateHistoryAction());
    }

    //---------------------------------- Private Company Block ------------------------------
    else if (action.type === 'portal/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      return await store.dispatch(saveStateToHistory(action.payload));
    } else if (action.type === 'BusinessDashboardSlice/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      return await store.dispatch(saveStateToHistory(action.payload));
    } else if (action.type === 'VisualIVRSlice/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      return await store.dispatch(saveStateToHistory(action.payload));
    }
    //---------------------------------- Dwh Report Management Block ------------------------------
    else if (action.type === 'dwhReportManagement/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      return await store.dispatch(saveStateToHistory(action.payload));
    } else if (action.type === 'funtoneSlice/saveToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      return await store.dispatch(saveStateToHistory());
    } else if (action.type === 'energyReplaceBlock/goToPage') {
      if (action.payload) {
        await store.dispatch(saveStateToHistory());
        next(pushPath(action.payload));
        next(action);
        return await store.dispatch(saveStateToHistory());
      }
    }
    //----------------------------------personalPricePlanBlock ------------------------------
    else if (action.type === 'personalPricePlan/backHistory') {
      const previousKey = getPreviousHistoryKeyAndPop(action);
      if (previousKey) {
        const loadedState = loadStateFromHistory(previousKey);
        if (loadedState?.personalPricePlan) {
          next(restoreFromHistory('personalPricePlan', loadedState.personalPricePlan));
          store.dispatch(pushPath(loadedState.personalPricePlan.currentStep));
        }
      }
      return next(action);
    } else if (action.type === 'personalPricePlan/pushToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      await store.dispatch(saveStateToHistory());
      pushHistoryKey(action);
      return;
    } else if (action.type === 'personalPricePlan/saveToHistory') {
      if (action.payload) {
        const result = await store.dispatch(saveStateToHistory(action.payload));
        pushHistoryKey(action);
        return result;
      }
    } else if (action.type === 'personalPricePlan/clearHistory') {
      clearHistoryKeyStack(action.type);
      return await store.dispatch(clearStateHistoryAction());
    }

    //---------------------------------- Organization Family Member Block ------------------------------

    else if (action.type === 'organizationEmployee/backHistory') {
      const previousKey = getPreviousHistoryKeyAndPop(action);
      if (previousKey) {
        const loadedState = loadStateFromHistory(previousKey);
        if (loadedState?.organizationEmployee) {
          next(restoreFromHistory('organizationEmployee', loadedState.organizationEmployee));
          store.dispatch(pushPath(loadedState.organizationEmployee.currentStep));
        }
      }
      return next(action);
    } else if (action.type === 'organizationEmployee/pushToHistory') {
      if (action.payload) {
        next(pushPath(action.payload));
      }
      await store.dispatch(saveStateToHistory());
      pushHistoryKey(action);
      return;
    } else if (action.type === 'organizationEmployee/saveToHistory') {
      if (action.payload) {
        const result = await store.dispatch(saveStateToHistory(action.payload));
        pushHistoryKey(action);
        return result;
      }
    } else if (action.type === 'organizationEmployee/clearHistory') {
      clearHistoryKeyStack(action.type);
      next(action);
      return await store.dispatch(clearStateHistoryAction());
    }

  }
  return next(action);
};
